module.exports = __webpack_public_path__ + "img/scholar3.e80a233f.png";